// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.ArrowDownSmall = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.ArrowDownSmall = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var ArrowDownSmall = _exports.ArrowDownSmall = function ArrowDownSmall(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M13.7742 13.7767L10.4409 17.11C10.3834 17.1675 10.3143 17.2132 10.2384 17.2449C10.1626 17.2765 10.0808 17.2933 9.99917 17.2933C9.9175 17.2933 9.83657 17.2765 9.75991 17.2449C9.68324 17.2132 9.61497 17.1675 9.55747 17.11L6.22414 13.7767C5.97997 13.5325 5.97997 13.1366 6.22414 12.8925C6.46831 12.6483 6.86417 12.6483 7.10834 12.8925L9.37498 15.1591V3.33496C9.37498 2.98996 9.65498 2.70996 9.99998 2.70996C10.345 2.70996 10.625 2.98996 10.625 3.33496V15.1591L12.8916 12.8925C13.1358 12.6483 13.5317 12.6483 13.7758 12.8925C14.02 13.1366 14.0184 13.5325 13.7742 13.7767Z",
      fill: "currentColor"
    }));
  };
});
